import React from 'react'
import { adminPageWrap } from './adminDesignTokens'

export default function AdminRouteFallback() {
  return (
    <div style={adminPageWrap}>
      <div className="admin-skeleton" style={{ height: 28, width: 220, marginBottom: 12 }} />
      <div className="admin-skeleton" style={{ height: 16, width: 420, marginBottom: 24 }} />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12, marginBottom: 20 }}>
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="admin-skeleton" style={{ height: 80, borderRadius: 12 }} />
        ))}
      </div>
      <div className="admin-skeleton" style={{ height: 280, borderRadius: 12 }} />
    </div>
  )
}
